var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("report-page", {
    attrs: {
      title: _vm.name,
      "data-to-send": _vm.dataToSend,
      "buttons-disabled": _vm.buttonsDisabled,
      "history-filter": _vm.historyFilter,
      selectedWorkspaceUUID: _vm.selectedWorkspace
    },
    scopedSlots: _vm._u([
      {
        key: "reportForm",
        fn: function() {
          return [
            _c(
              "report-field",
              { attrs: { "field-name": _vm.$tc("Workspace", 1) } },
              [
                _c("treeselect", {
                  attrs: {
                    options: _vm.workspaceOptions,
                    disabled:
                      _vm.workspaceSelectionDisabled ||
                      !_vm.userHasManagementPermission("workspace", "list") ||
                      !_vm.hasPermissionToCreateExport,
                    disableFuzzyMatching: ""
                  },
                  model: {
                    value: _vm.selectedWorkspace,
                    callback: function($$v) {
                      _vm.selectedWorkspace = $$v
                    },
                    expression: "selectedWorkspace"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.needsLayerSelection
              ? _c(
                  "report-field",
                  {
                    attrs: {
                      "field-name": _vm.$tc(_vm.reportParameters[0].label, 2)
                    }
                  },
                  [
                    _c("treeselect", {
                      attrs: {
                        options: _vm.layerOptions,
                        multiple: _vm.layersFieldIsMultiSelect,
                        disabled:
                          !_vm.hasPermissionToCreateExport ||
                          _vm.selectedWorkspace === undefined,
                        disableFuzzyMatching: ""
                      },
                      model: {
                        value: _vm.reportParameters[0].value,
                        callback: function($$v) {
                          _vm.$set(_vm.reportParameters[0], "value", $$v)
                        },
                        expression: "reportParameters[0].value"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-354a6960", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-354a6960","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/Tabs/Reports/ReportsPages/Photos.vue
// module id = null
// module chunks = 